import request from './adminRequest'

export const virtualMoneyApi = {
  listVideo (params) {
    return request.get('/videos', { params: params })
  },
  getVideo (videoId) {
    return request.get('/videos/' + videoId)
  },
  saveVideo (data) {
    return request.post('/videos/', data)
  },
  updateVideo (videoId, data) {
    return request.put('/videos/' + videoId, data)
  },
  deleteVideo (videoId) {
    return request.delete('/videos/' + videoId)
  },
  listVirtualMoneyRecord (params) {
    return request.get('/virtualMoney', { params: params })
  },
  getVirtualMoneyRecord (recordId) {
    return request.get(`/virtualMoney/${recordId}`)
  },
  getUserVirtualMoney (uid) {
    return request.get(`users/virtualMoney/${uid}`)
  },
  updateUserVirtualMoney (uid, data) {
    return request.post(`/users/virtualMoney/${uid}`, data)
  },
}
export default virtualMoneyApi
